import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { hours } from "./files";

class MerchantProfile extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.merchant;
  }
  price(prop) {
    return new Intl.NumberFormat("ca-EN", {
      style: "currency",
      currency: "CAD",
    }).format(prop / 100);
  }
  createOptions = () =>
    hours.map((hour, i) => (
      <option key={i} value={i}>
        {hours[i]}
      </option>
    ));
  render() {
    const { merchant } = this.props;

    const week = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return (
      <div className="container-fluid">
        <Fragment>
          <style type="text/css">
            {`
    .btn-flat {
      display: inline;
      background-color: #cdcecf;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #eaecef;
      color: #0492a9;
      border-radius: 8px;
border: 1px solid teal;  
    }
    `}
          </style>
          <Navbar className="bg-info justify-content-between">
            <Navbar.Brand>{merchant.name}</Navbar.Brand>
            <Link to="/stats">
              <Button variant="outline-light">Back to Stakeholders</Button>
            </Link>
          </Navbar>
          <Form className="bg-flat">
            <br></br>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridMerchant">
                <Form.Label>Merchant Name</Form.Label>
                <Form.Control
                  readOnly
                  name="merchantName"
                  value={merchant.name}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridWebsite">
                <Form.Label>Merchant Website</Form.Label>
                <Form.Control
                  name="website"
                  readOnly
                  value={merchant.website}
                />
              </Form.Group>
              <Col sm="2">
                <Form.Group>
                  <Form.Label>Shopify Store</Form.Label>
                  <Form.Check
                    name="shopify_store"
                    checked={merchant.shopify_store}
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Col sm="2">
                <Form.Group>
                  <Form.Label>Advanced Plan</Form.Label>
                  <Form.Check
                    name="advanced_plan"
                    checked={merchant.advanced_plan}
                    readOnly
                  />
                </Form.Group>
              </Col>
              <Form.Group as={Col} controlId="formGridDefSecur">
                <Form.Label>Default Security</Form.Label>
                <Form.Control
                  name="default_security"
                  readOnly
                  value={merchant.default_security}
                />
              </Form.Group>  
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridPricepoint">
                <Form.Label>PricePoint</Form.Label>
                <Form.Control
                  name="pricepoint"
                  readOnly
                  value={merchant.pricepoint}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridParent">
                <Form.Label>Parent Organization</Form.Label>
                <Form.Control
                  name="parent_organization"
                  readOnly
                  value={merchant.parent_organization}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridZone">
                <Form.Label>Zone</Form.Label>
                <Form.Control name="zone" readOnly value={merchant.zone} />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridVertical">
                <Form.Label>Vertical</Form.Label>
                <Form.Control
                  name="vertical"
                  readOnly
                  value={merchant.vertical}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridContactName">
                <Form.Label>Contact Name</Form.Label>
                <Form.Control
                  name="contact_name"
                  readOnly
                  value={merchant.contact_name}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formBasicEmail">
                <Form.Label>Contact Email</Form.Label>
                <Form.Control
                  type="email"
                  readOnly
                  value={merchant.contact_email}
                  name="contact_email"
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridPhone">
                <Form.Label>Contact Phone</Form.Label>
                <Form.Control
                  readOnly
                  value={merchant.contact_phone}
                  name="contact_phone"
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  readOnly
                  value={merchant.address}
                  name="address"
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="formGridCity">
                <Form.Label>City</Form.Label>
                <Form.Control readOnly value={merchant.city} name="city" />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridState">
                <Form.Label>Province</Form.Label>
                <Form.Control
                  readOnly
                  value={merchant.province}
                  name="province"
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridZip">
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                  readOnly
                  value={merchant.postal_code}
                  name="postal_code"
                />
              </Form.Group>
            </Form.Row>
            <Accordion>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="0"
                >
                  Store Hours
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <Form.Row>
                      {week.map((day, i) => (
                        <Form.Group key={week[i]} as={Col}>
                          <Form.Label>{week[i]}</Form.Label>
                          <Form.Control
                            readOnly
                            id={`open${i}`}
                            name="Open"
                            value={merchant.store_hours[i].Open}
                            as="select"
                          >
                            <option>Open</option>
                            {this.createOptions()}
                          </Form.Control>
                          <Form.Control
                            readOnly
                            id={`close${i}`}
                            name="Close"
                            value={merchant.store_hours[i].Close}
                            as="select"
                          >
                            <option>Close</option>
                            {this.createOptions()}
                          </Form.Control>
                        </Form.Group>
                      ))}
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="1"
                >
                  Text Alerts
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    {merchant.text_alerts_on && (
                      <Form.Group as={Form.Row} controlId="formPlainAlertPhone">
                        <Form.Label column>
                          Phone Number to Receive SMS Updates
                        </Form.Label>
                        <Col>
                          <Form.Control
                            readOnly
                            value={merchant.text_alerts_phone_number}
                            name="text_alerts_phone_number"
                          />
                        </Col>
                      </Form.Group>
                    )}
                    {merchant.inzone_order_alert_email1 && (
                      <Form.Group
                        as={Form.Row}
                        controlId="formPlainInzoneEmail1"
                      >
                        <Form.Label column>
                          Email to Receive Inzone Order Updates 
                        </Form.Label>
                        <Col>
                          <Form.Control
                            readOnly
                            value={merchant.inzone_order_alert_email1}
                            name="inzone_order_alert_email1"
                          />
                        </Col>
                      </Form.Group>
                    )}
                    {merchant.inzone_order_alert_email2 && (
                      <Form.Group
                        as={Form.Row}
                        controlId="formPlainInzoneEmail2"
                      >
                        <Form.Label column>
                          Email to Receive Inzone Order Updates - 2
                        </Form.Label>
                        <Col>
                          <Form.Control
                            readOnly
                            value={merchant.inzone_order_alert_email2}
                            name="inzone_order_alert_email2"
                          />
                        </Col>
                      </Form.Group>
                    )}
                    {merchant.delivery_alert_email && (
                      <Form.Group as={Form.Row} controlId="formPlainAlertEmail">
                        <Form.Label column>
                          Email to Receive Delivery Notification
                        </Form.Label>
                        <Col>
                          <Form.Control
                            readOnly
                            value={merchant.delivery_alert_email}
                            name="delivery_alert_email"
                          />
                        </Col>
                      </Form.Group>
                    )}
                    {merchant.delivery_booked_email && (
                      <Form.Group
                        as={Form.Row}
                        controlId="formPlainBookedEmail"
                      >
                        <Form.Label column>
                          Email to Receive Booked Delivery Notification
                        </Form.Label>
                        <Col>
                          <Form.Control
                            readOnly
                            value={merchant.delivery_booked_email}
                            name="delivery_booked_email"
                          />
                        </Col>
                      </Form.Group>
                    )}
                    {merchant.customer_support_email && (
                      <Form.Group
                        as={Form.Row}
                        controlId="formCustomerSupportEmail"
                      >
                        <Form.Label column>
                          Email to Receive Requests from Customers
                        </Form.Label>
                        <Col>
                          <Form.Control
                            readOnly
                            value={merchant.customer_support_email}
                            name="customer_support_email"
                          />
                        </Col>
                      </Form.Group>
                    )}
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="2"
                >
                  Price List
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainMerchantPrice">
                        <Form.Label>Merchant Price </Form.Label>
                        <Form.Control
                          readOnly
                          value={this.price(merchant.merchant_price)}
                          name="merchant_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formExchangePrice">
                        <Form.Label>Exchange Price </Form.Label>
                        <Form.Control
                          readOnly
                          value={this.price(merchant.exchange_price)}
                          name="exchange_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainAddSTDPrice">
                        <Form.Label>Add STD Item Price</Form.Label>
                        <Form.Control
                          readOnly
                          value={this.price(
                            merchant.additional_standard_item_price
                          )}
                          name="additional_standard_item_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainWeightThreshold">
                        <Form.Label>Weight Threshold</Form.Label>
                        <Form.Control
                          readOnly
                          value={`${merchant.weight_threshold / 1000} kg`}
                          name="weight_threshold"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainOverweightPrice">
                        <Form.Label>Overweight Price</Form.Label>
                        <Form.Control
                          readOnly
                          value={this.price(merchant.overweight_order_price)}
                          name="overweight_order_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainAddOWPrice">
                        <Form.Label>Add OW Item Price </Form.Label>
                        <Form.Control
                          readOnly
                          value={this.price(
                            merchant.additional_overweight_item_price
                          )}
                          name="additional_overweight_item_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainShipThreshold">
                        <Form.Label>Free Shipping Threshold</Form.Label>
                        <Form.Control
                          value={this.price(merchant.free_shipping_threshold)}
                          readOnly
                          name="free_shipping_threshold"
                        />
                      </Form.Group>{" "}
                      <Form.Group as={Col} controlId="formPlainShipCostNotfree">
                        <Form.Label>Shipping Cost If Not Free </Form.Label>
                        <Form.Control
                          value={this.price(merchant.shipping_cost_if_not_free)}
                          readOnly
                          name="shipping_cost_if_not_free"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="3"
                >
                  Delivery Details
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainDeliveryTitle">
                        <Form.Label>Delivery Title</Form.Label>
                        <Form.Control
                          value={merchant.delivery_title}
                          readOnly
                          name="delivery_title"
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        controlId="formPlainDeliveryDescription"
                      >
                        <Form.Label>Delivery Description</Form.Label>
                        <Form.Control
                          value={merchant.delivery_description}
                          readOnly
                          name="delivery_description"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainPickupNotes">
                        <Form.Label>Pick Up Notes</Form.Label>
                        <Form.Control
                          value={merchant.pick_up_notes}
                          readOnly
                          name="pick_up_notes"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainAllowedFsas">
                        <Form.Label>Allowed FSAs</Form.Label>
                        <Form.Control
                          value={merchant.allowed_fsas}
                          readOnly
                          name="allowed_fsas"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="4"
                >
                  Billing Details
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainBillingContact">
                        <Form.Label>Billing Contact</Form.Label>
                        <Form.Control
                          value={merchant.billing_contact}
                          readOnly
                          name="billing_contact"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainBillingEmail">
                        <Form.Label>Billing Email</Form.Label>
                        <Form.Control
                          value={merchant.billing_email}
                          readOnly
                          name="billing_email"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainPaymentTerms">
                        <Form.Label>Payment Terms</Form.Label>
                        <Form.Control
                          value={merchant.payment_terms}
                          readOnly
                          name="payment_terms"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainPaymentDays">
                        <Form.Label>Payment Days</Form.Label>
                        <Form.Control
                          value={merchant.payment_days}
                          readOnly
                          name="payment_days"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Form>
          <Link to="/stats">
            <Button variant="outline-info">Back to Stakeholders</Button>
          </Link>
        </Fragment>
      </div>
    );
  }
}

export default withRouter(MerchantProfile);
